// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ml-1";
export var messageSideRight = "_ml-2";
export var orderLookupBubbleContainer = "_ml-0";
export var submitButton = "_ml-3";